module.exports = __webpack_public_path__ + "static/media/2015_conf_Five_Lessons_from_the_Battelfield.d61a0537.png";